import { cn as e } from "../../shared/utils.js";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
import { Switch as r } from "@base-ui/react/switch";
//#region src/toggle/primitive/index.tsx
var i = t(({ className: t, ...i }, a) => /* @__PURE__ */ n(r.Root, {
	ref: a,
	className: e("bg-control-default relative inline-flex h-[19px] w-8 shrink-0 cursor-pointer items-center rounded-full p-0 outline-none", "transition-base transition-[background-color,box-shadow]", "hover:shadow-[inset_0_0_0_2px_var(--color-control-border-hover)]", "focus-visible:focus-ring-primary", "data-checked:bg-control-active data-checked:hover:bg-control-active-hover data-checked:hover:shadow-none", "data-disabled:bg-control-disabled data-disabled:cursor-not-allowed data-disabled:shadow-none", "data-checked:data-disabled:bg-control-active-disabled", t),
	...i
})), a = t(({ className: t, ...i }, a) => /* @__PURE__ */ n(r.Thumb, {
	ref: a,
	className: e("bg-control-bg pointer-events-none absolute top-1 left-1 size-[11px] rounded-full", "transition-base transition-transform", "data-checked:translate-x-[13px]", t),
	...i
}));
i.displayName = r.Root.displayName, a.displayName = r.Thumb.displayName;
var o = {
	Root: i,
	Thumb: a
};
//#endregion
export { o as Toggle };
